import { Injectable } from '@angular/core';
import { SelectItemDto } from '@bugz-mono/shared-dtos';
import { Country, State, City } from 'country-state-city';

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  getTelCompanyTypes() : SelectItemDto[] {
    return [
      { id:1, name: "DIGI"},     { id:2, name: "FLEXIROAM"},  { id:3, name: "IDEA"},
      { id:4, name: "MAXIS"},    { id:5, name: "MYEVO"},      { id:6, name: "SINTEL"},
      { id:7, name: "TELKOMSEL"},{ id:8 , name: "VODAFONE"},  { id:9 , name: "XPAX"},
    ];
  }
  getDeviceCompanies() : SelectItemDto[] {
    return [ { id:1, name: "Maark"}, { id:2, name: "ITCD"}, { id:3, name: "Beiduo"},]
    .sort((a, b) => a.name.localeCompare(b.name));
  }
  getDeviceTypes() : SelectItemDto[] {
    return [
      { id:1, name: "TK510"},{ id:2, name: "TK208"},{ id:3, name: "TK228"},{ id:4, name: "GT08"},{ id:5, name: "MT05"},{ id:6, name: "Concox"},
      { id:7, name: "Beiduo"},{ id:8 , name: "ITCD"} ]
      .sort((a, b) => a.name.localeCompare(b.name));
  }
  getDeviceStatuses(): SelectItemDto[] {
    return [
      { id:1, name: "(unassigned)"},{ id:2, name: "Warranty"},{ id:3, name: "Spoil"},{ id:4, name: "Terminate"}]
      .sort((a, b) => a.name.localeCompare(b.name));
  }
  getSimStatuses(): SelectItemDto[] {
    return [
      { id:1, name: "Unassigned"},{ id:2, name: "Warranty"},{ id:3, name: "Spoil"},{ id:4, name: "Terminate"}]
      .sort((a, b) => a.name.localeCompare(b.name));
  }
  generateRandomPassword(length: number = 6): string {
    const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let password = '';
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * charset.length);
      password += charset[randomIndex];
    }
    return password;
  }
  getCountries() {
    const rawCountries =Country.getAllCountries();
    const countries = rawCountries.map((country) => ({
      name: country.name,
      flag: `https://flagcdn.com/w40/${country.isoCode.toLowerCase()}.png`,
      isoCode: country.isoCode,
      phonecode: country.phonecode,
    }));
    return countries;
  }
  getCountryFlagByName(countryName?:string){
    const countries = Country.getAllCountries();
    const country = countries.find((c) => c.name.toLowerCase() === countryName?.toLowerCase());
    if(country){
      return `https://flagcdn.com/w40/${country.isoCode?.toLowerCase()}.png`
    }
    return '';
      
  }
  getCountryFlag(countryCode?:string){
    return `https://flagcdn.com/w40/${countryCode?.toLowerCase()}.png`
  }
  getCountryStates(isoCode: string | undefined) {
    const rawStates =State.getStatesOfCountry(isoCode);
    const states = rawStates.map((state) => ({
      name: state.name,
    }));
    return states;
  }
  concatJsonStrings(...values: (string | null | undefined)[]): string {
    return values
      .filter(value => value !== null && value !== undefined && value.trim() !== "") // Remove null, undefined, and empty strings
      .join(","); // Join with a comma and space
  }
  combineAndOr(andCombine?:boolean){
    return andCombine?'and':'or';
  }
  getVehicleTypeIcon(type:string): string{
    switch(type){
      case 'Car': return 'directions_car'; break;
      case 'Bike': return 'two_wheeler'; break;
      case 'Truck': return 'local_shipping'; break;
      default: return 'error';
    }
    return 'error';
  }

  getMimeType(extension: string): string | null {
    const mimeTypes: { [key: string]: string } = {
      jpg: 'image/jpeg',
      jpeg: 'image/jpeg',
      png: 'image/png',
      gif: 'image/gif',
      bmp: 'image/bmp',
      svg: 'image/svg+xml',
      webp: 'image/webp',
      tiff: 'image/tiff',
      pem: 'application/x-pem-file',
    };
    return mimeTypes[extension.toLowerCase()] || null;
  }

  getCenter(locations: { lat: number; lng: number }[]): { lat: number; lng: number } {
    const total = locations.length;
    const avgLat = locations.reduce((sum, loc) => sum + loc.lat, 0) / total;
    const avgLng = locations.reduce((sum, loc) => sum + loc.lng, 0) / total;
    return { lat: avgLat, lng: avgLng };
  }
  
  
}